var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPadLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#E7E7E7",
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8136,
    y: 15.7964,
    width: 25.2654,
    height: 6.11533,
    transform: "rotate(134.453 39.8136 15.7964)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4402,
    y: 41.2925,
    width: 6.75984,
    height: 18.5232,
    transform: "rotate(135.209 39.4402 41.2925)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 27.58L34.76 11L40.42 16.66L28.08 29L40.42 41.34L34.78 47L18.18 30.42C17.9926 30.2341 17.8438 30.0129 17.7423 29.7692C17.6407 29.5254 17.5884 29.264 17.5884 29C17.5884 28.736 17.6407 28.4746 17.7423 28.2308C17.8438 27.9871 17.9926 27.7659 18.18 27.58Z",
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPadLeft);
export default __webpack_public_path__ + "static/media/button-pad-left.fac77c8076491a06de3745cbf244330d.svg";
export { ForwardRef as ReactComponent };